
import type { PropType } from 'vue'
import type { Equalize } from '../../modules/equalize'
import type { EqualizeDomainService } from '../../services/interfaces'
import { computed, defineComponent, getCurrentInstance } from 'vue'
import { mapGetters } from '../../composables/utils'

import { CONTAINER } from '../../config'

import { TYPES } from '../../config/inversify.types'

import { capitalizeSentence } from '../../filters/capitalize-sentence.filter'

import { CONFIG_CONSTS } from '../../store/config/config.consts'

import { EpbSlide } from '../shared/epb-slide'
import EqualizeFeatureContainer from './equalize-feature-container.component.vue'

export default defineComponent({
  name: 'TextualMatchFeatureContainer',
  components: {
    EpbSlide,
    EqualizeFeatureContainer,
  },
  props: {
    item: {
      type: Object as PropType<Equalize>,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
    },
    disabled: Boolean,
    messages: {
      type: Object,
      required: true,
    },
  },
  setup(props: { item: Equalize; readonly: boolean; messages: object }) {
    const {
      proxy: { $store },
    } = getCurrentInstance()

    const domainService = CONTAINER.get<EqualizeDomainService>(TYPES.EqualizeDomainService)

    const defaultButtonDisabled = computed((): boolean => {
      return Object.keys(props.item.defaultFeatures).length
        ? domainService.hasTextualMatchDefaultValues(
            props.item.features,
            props.item.defaultFeatures,
          )
        : false
    })

    const { instanceConfig } = mapGetters($store, CONFIG_CONSTS.moduleName, {
      instanceConfig: CONFIG_CONSTS.getters.currentInstance,
    })

    const getPrettyName = (name: string): string => {
      const catalogFieldConfig = instanceConfig.value.catalog.fields.find(({ id }) => id === name)

      return capitalizeSentence(catalogFieldConfig?.prettyName ?? name)
    }

    const baseClass = 'epb-textual-match-feature-container'

    const setDefaultValues = (): void => {
      domainService.setDefaultByFeature(
        'multiMatchSearch',
        props.item.features,
        props.item.defaultFeatures,
      )
    }

    return {
      baseClass,
      domainService,
      defaultButtonDisabled,
      setDefaultValues,
      getPrettyName,
    }
  },
})
